import { render, staticRenderFns } from "./PrijavaULigu.vue?vue&type=template&id=0db6717e&scoped=true&"
import script from "./PrijavaULigu.vue?vue&type=script&lang=js&"
export * from "./PrijavaULigu.vue?vue&type=script&lang=js&"
import style0 from "./PrijavaULigu.vue?vue&type=style&index=0&id=0db6717e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db6717e",
  null
  
)

export default component.exports